// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2A0B-";
var _4 = "header-SRNYg";
var _5 = "body-1iUCX";
var _6 = "footer--MPGS";
var _7 = "promo_message-123Fg";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "header", _5 as "body", _6 as "footer", _7 as "promo_message" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "header": _4, "body": _5, "footer": _6, "promo_message": _7 }
